import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  Tooltip
} from '@material-ui/core';
import classNames from 'classnames';

const styles = theme => ({
  wrapper: {
    marginRight: 5,
    //marginBottom: 5,
    borderRadius: 4,
    //border: '1px solid',
    //borderColor: theme.palette.secondary.main,
  },
  wrapperSmall: {
    fontSize: '.775rem',
    lineHeight: 1.3
  },
  name: {
    //backgroundColor: theme.palette.grey['600'],
    padding: '0 4px 0 0',
    //borderRadius: '4px 0 0 4px'
    fontSize: '1rem'
  },
  value: {
    //backgroundColor: theme.palette.secondary.main,
    padding: '0 4px 0 0',
    //borderRadius: '0 4px 4px 0',
    //color: theme.palette.primary.contrastText,
    fontWeight: 500,
    fontSize: '1rem'
  },
  valueSmall: {
    minWidth: 50
  },
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  invalidText: {
    color: 'red'
  }
});

const IconKeyValue = ({ classes, name, value, reverse, showInvalidText }) => {
  return (
    <Tooltip title={showInvalidText ? `${name} must be less than or equal to 10`: ''}>
      <div className={classes.container}>
        {/* <SvgIcon>
          <path d={iconPath} />
        </SvgIcon> */}
        <Typography noWrap variant="body2" className={classNames(reverse ? classes.name : classes.value, showInvalidText && classes.invalidText)}>{`${reverse ? name : (value || '--')}`}</Typography>
        <Typography noWrap variant="body2" className={classNames(reverse ? classes.value : classes.name, showInvalidText && classes.invalidText)}>{`${reverse ? (value || '--') : name}`}</Typography>
        {/* <Typography className={classNames(classes.value, (small && classes.valueSmall))}>{value || '-'}</Typography> */}
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(IconKeyValue);
